import React from 'react';

const SvgKh = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KH_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KH_svg__b" fill="#fff">
        <use xlinkHref="#KH_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#KH_svg__a" />
      <path
        fill="#0F3EB6"
        mask="url(#KH_svg__b)"
        d="M0 0h28v5.333H0zM0 14.667h28V20H0z"
      />
      <path fill="#ED1A3C" mask="url(#KH_svg__b)" d="M0 5.333h28v9.333H0z" />
      <path
        d="M10 10.667h1.333v2.666H8.667L10 10.667zm2 0h4v2.666h-4v-2.666zm4.667 0H18l1.333 2.666h-2.666v-2.666zm0-2.001c0-.368.296-.666.666-.666.369 0 .667.295.667.666V10h-1.333V8.666zM12 8.727h1.333v-.73c0-.366.296-.664.667-.664.368 0 .667.296.667.665v.73H16V10h-4V8.727zm-2-.061c0-.368.296-.666.667-.666.368 0 .666.295.666.666V10H10V8.666z"
        fill="#FFF"
        mask="url(#KH_svg__b)"
      />
    </g>
  </svg>
);

export default SvgKh;
